export const RunningDays = {
  WORKING_DAYS: "working-days",
  CALENDAR_DAYS: "calendar-days"
};
